import { Link } from "gatsby"
import React from "react"
import { SEOHead } from "components/SEO"
import Section from "components/Layout/Section"
import Layout from "components/ui/Layout"

function NotFoundPage({ location: { pathname } }) {
  return (
    <Layout pageName="404" pagePath={pathname}>
      <Section>
        <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
          <h1>Page Not Found</h1>
          <p style={{ fontSize: "1.2rem", color: "#666", marginBottom: 40 }}>
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>

          <div
            style={{
              textAlign: "left",
              background: "#f8f9fa",
              borderRadius: 8,
              padding: "24px 32px",
              marginBottom: 32,
            }}
          >
            <h2 style={{ fontSize: "1.1rem", marginBottom: 16, color: "#333" }}>
              Here are some helpful links:
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 12 }}>
                <Link to="/">Home</Link> — Return to our homepage
              </li>
              <li style={{ marginBottom: 12 }}>
                <Link to="/blog/">Blog</Link> — Read our latest articles
              </li>
              <li style={{ marginBottom: 12 }}>
                <Link to="/pricing/">Pricing</Link> — Explore our plans
              </li>
              <li style={{ marginBottom: 12 }}>
                <Link to="/apache-superset/">Apache Superset</Link> — Learn
                about the open-source BI platform
              </li>
              <li style={{ marginBottom: 12 }}>
                <a href="https://docs.preset.io">Documentation</a> — Browse our
                help docs
              </li>
            </ul>
          </div>
        </div>
      </Section>
    </Layout>
  )
}

export function Head() {
  return (
    <SEOHead
      title="404: Page Not Found"
      description="The page you're looking for doesn't exist. Find your way back with our helpful navigation links."
      thumbnail={false}
    />
  )
}

export default NotFoundPage
